<!-- 合肥首页 -->
<template>
  <div>
    <div></div>
    <div>
      <b-container>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card no-body class="overflow-hidden mt-2" @click="toApplyCard()">
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/hefei/img_apply_hs0.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6>
                          <b>卡片申请</b>
                        </h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">申请</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="toQueryOrder()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/hefei/img_apply_hs.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>进度查询</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">查询</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <div style="font-size: 0.9rem; margin-top: 1rem">
              客服电话：17756086603
            </div>
          </b-col></b-row
        >
      </b-container>
      <!-- 卡类型接口数据 -->
      <!-- <button @click="_getCardTypeList()">卡类型接口数据</button> -->
    </div>

    <b-modal ref="model_update" title="提示" ok-title="确定" ok-only>
      <p>系统升级中，申请普通卡和进度查询功能暂不能使用</p>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "Home_hf",
  data() {
    return {
      isUpdate: false,
      bankCode: config.config_hf.bankCode,
      cardList: [],
    };
  },
  mounted: function () {
    console.log("Home_hf mounted");
    this.$store.commit("hf/resetState");
    //初始入口 1 申请卡面，2 查询进度 -1默认值
    sessionStorage.setItem("entrance", -1);
    let storeStr = JSON.stringify(this.$store.state.sh);
    console.log("storeStr:" + storeStr);
    if (this.isUpdate) {
      this.showUpdateMsg();
    }
  },
  methods: {
    // 普通卡申请
    toApplyCard: function () {
      if (this.isUpdate) {
        return;
      }
      sessionStorage.setItem("entrance", 1);
      console.log("this.$store.state.sh--->", this.$store.state.sh);
      this.$router.push({
        name: "ApplyCard_hf",
      });
    },
    // 进度查询
    toQueryOrder: function () {
      if (this.isUpdate) {
        return;
      }
      sessionStorage.setItem("entrance", 2);
      console.log(this.$store.state.sh);
      this.$router.push({
        name: "QueryOrder_hf",
      });
    },
    showUpdateMsg: function () {
      this.$refs["model_update"].show();
    },
    // 获取卡种类列表
    _getCardTypeList() {
      let that = this;
      let param = {
        companyType: 2,
        bankCode: this.bankCode,
      };
      console.log("param--->", param);
      axios.get(config.config_hf.getCardTypeList).then((res) => {
        that.cardList = res.data.data;
        console.log("cardList--->", cardList);
      });
    },
  },
};
</script>

<style scoped>
.img {
  width: 100vw;
}

.btnClass {
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/hefeibank/Home_hf.vue